import type { AppFooterConfig, FooterLink, FooterLinkGroup } from './app-footer.config';
import { buildStatusAppUrl } from './status-link';

/**
 * `AppFooterConfig`의 `statusAppSlug`(있으면 "상태확인" 링크를 맨 앞에 추가)와
 * `linkGroups`를 하나의 평평한 링크 목록으로 합친다. 전체 푸터(`AppFooterComponent`)와
 * 압축 푸터(`AppFooterCompactComponent`)가 같은 로직을 공유한다 — 한쪽만 고치고
 * 잊어버리는 drift를 막기 위해서다.
 */
export function resolveFooterLinks(config: AppFooterConfig): readonly FooterLink[] {
  const statusGroup: FooterLinkGroup | null = config.statusAppSlug
    ? {
        title: '서비스',
        links: [{ label: '상태확인', href: buildStatusAppUrl(config.statusAppSlug) }],
      }
    : null;
  const groups = config.linkGroups ?? [];
  const allGroups = statusGroup ? [statusGroup, ...groups] : groups;
  return allGroups.flatMap((group) => group.links);
}
